export const DIVIDER_H = 16
export const MIN_VIZ_H = 240
export const MIN_TABLE_H = 140

export type SplitDimensions = {
  vizH: number
  overlapPx: number
  effectiveTableH: number
}

// Given the available host height and the user's desired table height,
// returns the heights for the viz pane, the table, and how much they overlap.
// Overlap means the table is taller than the host can comfortably fit, so it
// floats over the viz pane (with a shadow) instead of squashing it below MIN_VIZ_H.
export function computeSplit(
  hostH: number,
  tableH: number,
  tableOpen: boolean,
): SplitDimensions {
  const effectiveTableH = tableOpen ? tableH : 0
  const maxNonOverlapTableH = Math.max(MIN_TABLE_H, hostH - DIVIDER_H - MIN_VIZ_H)
  const overlapPx = Math.max(0, effectiveTableH - maxNonOverlapTableH)
  const vizH = Math.max(MIN_VIZ_H, hostH - DIVIDER_H - Math.min(effectiveTableH, maxNonOverlapTableH))
  return { vizH, overlapPx, effectiveTableH }
}

export function clampTableH(h: number, hostH: number): number {
  const max = Math.max(MIN_TABLE_H, hostH - 180)
  return Math.max(MIN_TABLE_H, Math.min(max, h))
}